<div *ngIf="userContextFields; else emptyContent" class="row">
    <label>{{ 'ActorContextDialogMessage' | translate }}</label>
    <label>{{ 'ActorContextDialogCSKMessage' | translate }}</label><br>
    <ng-container *ngFor="let field of userContextFields">
      <lm-application-menu-user-context-field
          [userContextField]="field"
          (contextValueChanged)="onContextValueChanged(field)"
          (modelDirty)="onModelDirty($event)"
      ></lm-application-menu-user-context-field>
    </ng-container>
</div>
<ng-template #emptyContent>
  <label>{{ 'ActorContextDialogEmpty' | translate }}</label>
</ng-template>

